import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Chat from '../views/Chat.vue'
// import AddRoom from '../components/chat/AddRoom'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/intrebari',
    name: 'Intrebari',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Intrebari.vue')
  },
  {
    path: '/maps',
    name: 'Maps',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Maps.vue')
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "SignIn" */ '../views/user-login/SignIn.vue')
  },
  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Register" */ '../views/user-login/Register.vue')
  },
  {
    path: '/forum',
    name: 'Forum',
    component: () => import('../views/Forum.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/resources',
    name: 'Resources',
    component: () => import('../views/Resources.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('../views/401.vue')
  },
  
  {
    path: '/adminchat',
    name: 'AdminChat',
    component: () => import('../views/AdminChat.vue')
  },
  {
    path:'/post',
    name:'Post',
    component:()=> import('../views/Post.vue')
  },
  {
    path:'/privacy',
    name:'Privacy',
    component:()=> import('../views/Privacy.vue')
  },
  {
    path:'/despre',
    name:'Despre',
    component:()=> import('../views/Despre.vue')
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('../views/404.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes

})

export default router
